export default __webpack_public_path__ + "static/media/bg-slide.b80b730e.png";